<template>
      <div class="vsebina ">

    <div class="glava_vsebine adapt v-adapt">

      <div class="cols">
      <div class="col left grid-col-6">
        <h1>Stranka {{shema}}</h1>
      </div>
      
      
      
      <div class="col right">
      </div>
      
      </div>
    </div>
    
    <div class="telo_vsebine adapt v-adapt">
<div v-if="!pridelovalecid">
    NI PODATKOV
</div>
<div v-else>
<div>
        <div :style="{ display: 'inline-block' }">
            Sezona
            <br />
            <dropdownlist
                :data-items="sezonePisanje"
                :text-field="'sezona'"
                @change="sezonaChange"
                :value="dataSezona"
            />
                <pridelovalec :pridelovalec="pridelovalec" shema="IP" :sezona="dataSezona.sezona">
          </pridelovalec>
            
          </div>
        </div>
 <div class="uporabnik-spacer" style="margin-top:2rem"></div>
<div class="">
<form @submit.prevent="handleSubmit" class="k-form">
            <div class="form-group">
                  <div class="km-widget km-buttongroup k-widget k-button-group">
                <button class="k-button k-primary" :disabled="pridelovalec.pisanje==0" @click="saveData" >Shrani</button>
                <button class="k-button k-primary" @click="nazaj" >Nazaj</button>
               </div>
             </div>


     <div class="display-flex pt-1">

    <div>
        <fieldset class="left-border-for-children">
            <div class="form-fieldset-header">
                <h2> Profil</h2>
            </div>

            <div class="display-flex" style="align-items:center;gap:1rem;">  
            <label for="kntst" class="k-form-field">
            <span>Kontrolna številka</span>
             <input type="text" v-model="kontrolnaStevilka" placeholder="Kontrolna številka" name="kntst" id="kntst" class="k-textbox" />
            </label>
            </div>

            <div class="display-flex" style="align-items:center;gap:1rem;">  
            <label for="davcnizavezanec" class="k-form-field k-checkbox-field">
			<span>Davčni zavezanec</span>
			<input type="checkbox" v-model="ip.davcnizavezanec"  name="davcnizavezanec" id="davcnizavezanec" class="k-checkbox " />
            </label>
            </div>

            
            <div class="display-flex" style="align-items:center;gap:1rem;">  
                <label for="eracun" class="k-form-field k-checkbox-field" style="flex-shrink:0">
			    <span>Prejemnik e-računa</span>
			    <input type="checkbox" v-model="ip.eracun"  name="eracun" id="eracun" class="k-checkbox " />
                </label>
                <input v-if="ip.eracun" type="text" v-model="ip.eracunemail" placeholder="Naslov" name="eracunemail" id="eracunemail" class="k-textbox k-form-field" />
            </div>

            <div class="display-flex" style="align-items:start;gap:1rem;">
                <span class="k-form-field">Cena</span>  
                <div>
                    <label for="poceniku" class="k-form-field k-checkbox-field">
			            <span>po ceniku</span>
			            <input type="checkbox" v-model="ip.poceniku"  name="poceniku" id="poceniku" class="k-checkbox " checked />
                    </label>

                    <div class="display-flex" style="align-items:center;gap:1rem;">  
                        <label for="poponudbi" class="k-form-field k-checkbox-field" style="flex-shrink:0">
                        <span>po ponudbi z dne</span>
                        <input type="checkbox" v-model="ip.poponudbi"  name="poponudbi" id="poponudbi" class="k-checkbox " />
                        </label>
                        <kendo-datepicker class="k-form-field" id="poponudbidatum"
                        v-if="ip.poponudbi"
                        v-model="ip.poponudbidatum"
                        :format="'dd.MM.yyyy'">
                        </kendo-datepicker>
                        
                    </div>

                    <div class="display-flex" style="align-items:center;gap:1rem;">  
                        <label for="popust" class="k-form-field k-checkbox-field" style="flex-shrink:0">
                        <span>popust</span>
                        <input type="checkbox" v-model="ip.popust"  name="popust" id="popust" class="k-checkbox " />
                        </label>
                        <input v-if="ip.popust" type="text" v-model="ip.popustznesek" placeholder="Popust" name="popustznesek" id="popustznesek" class="k-textbox k-form-field" />
                    </div>

                </div>
               
			
			</div>

            <label for="individualno" class="k-form-field k-checkbox-field">
                <span>Individualno certificiranje</span>
                <input type="checkbox" v-model="ip.individualno"  name="individualno" id="individualno" class="k-checkbox" />
            </label>
            
            <div class="display-flex">            
            <label for="skupinsko" class="k-form-field k-checkbox-field">
                <span>Skupinsko certificiranje</span>
                <input type="checkbox" v-model="ip.skupinsko"  name="skupinsko" id="skupinsko" class="k-checkbox" />
            </label>
            </div>
            <div class="display-flex" style="align-items:end;">            
            <label for="izbranosteviloclanov" class="k-form-field">
            <span>Št. članov</span>
             <input type="text" v-model="ip.izbranosteviloclanov" placeholder="Število članov" name="izbranosteviloclanov" id="izbranosteviloclanov" class="k-textbox" />
            </label>
            <label for="izbrandatumdolocitvestevilaclanov" class="k-form-field">
            <span>Na datum</span>
             <kendo-datepicker id="izbrandatumdolocitvestevilaclanov"
                       v-model="ip.izbrandatumdolocitvestevilaclanov"
                       :format="'dd.MM.yyyy'">
            </kendo-datepicker>
            </label>
            <div>
            <button class="k-button k-secondary " style="font-size:16px;padding:6px;">
            <font-awesome-icon icon="history"/>
            </button>
            </div>
            

            </div>

            

            <label for="stevilkapogodobe" class="k-form-field">
            <span>Številka pogodbe</span>
             <input type="text" v-model="ip.stevilkapogodobe" placeholder="Številka pogodbe" name="stevilkapogodobe" id="stevilkapogodobe" class="k-textbox" />
            </label>
            

            



                <div class="k-form-field">
                    <span>Področja certificiranja</span>
                <div>
                </div>

                <template v-for="(podshema,i) in ip.podrocjacertificiranja">
                  
                    <div class="display-flex" style="align-items:end;">
                        <label>
                    <span class="k-button k-primary">
                          {{podshema.naziv}}
                    </span>
                    </label>
                    <label for="status" class="k-form-field flex-grow-1">
                        <span v-if="i==0">Status</span>
                        <dropdownlist
                         name="status"
                        :data-items="statusip"
                        :text-field="'naziv'"
                        v-model="podshema.status"
                        />
                </label>
                 <label :for="'izbrandatumdolocitvestatusa'+i" class="k-form-field">
                <span v-if="i==0">Na datum</span>
                 <kendo-datepicker :id="'izbrandatumdolocitvestatusa'+i"
                           v-model="podshema.izbrandatumdolocitvestatusa"
                           :format="'dd.MM.yyyy'">
                </kendo-datepicker>
                </label>
                <div>
                <button class="k-button k-secondary " style="font-size:16px;padding:6px;">
                <font-awesome-icon icon="history"/>
                </button>
                </div>
                
                </div>
            </template>

                    
                </div>
            

                       
             <label for="vloga" class="k-form-field">
                <span>{{kontakt.vloga}}</span>

              </label>
            <label for="ime" class="k-form-field">
                <span>Naziv</span>
                <input type="text" v-model="kontakt.naziv"  placeholder="Naziv" name="ime" class="k-textbox" disabled/>
            </label>
            <label for="naslovnosilca" class="k-form-field">
                <span>Naslov</span>
                <input type="text" v-model="kontakt.naslov" placeholder="Naslov"  name="naslovnosilca" class="k-textbox" disabled/>
            </label>
           <div class="k-form-field display-flex">
            <label for="postnastevilkanosilca">
                <span>Poštna številka</span>
                <input type="text" v-model="kontakt.postnastevilka"  placeholder="Poštna številka" name="postnastevilkanosilca" class="k-textbox" disabled/>
            </label>
            <label for="postanosilca" class="flex-grow-1" >
                <span>Pošta</span>
                <input type="text" v-model="kontakt.posta"  placeholder="Pošta" name="postanosilca" class="k-textbox" disabled/>
            </label>
            </div>
            <div class="k-form-field display-flex">
            <label for="kodadrzave">
                <span>Koda države</span>
                <input type="text" v-model="kontakt.kodadrzave"  placeholder="Koda države" name="kodadrzave" class="k-textbox" disabled/>
            </label>
            <label for="drzava" class="flex-grow-1" >
                <span>Država</span>
                <input type="text" v-model="kontakt.drzava"  placeholder="Država" name="drzava" class="k-textbox" disabled/>
            </label>
            </div>
          <label for="telefonnosilca" class="k-form-field">
                <span>Telefon</span>
                <input type="text" v-model="kontakt.telefon"  placeholder="Telefon" name="telefonnosilca" class="k-textbox" disabled/>
            </label>
            <label for="emailnosilca" class="k-form-field">
                <span>E-pošta</span>
                <input type="text" v-model="kontakt.email"  placeholder="Email" name="emailnosilca" class="k-textbox" disabled />
            </label>
            <label for="spletnastran" class="k-form-field">
                <span>Spletna stran</span>
                <input type="text" v-model="kontakt.spletnastran"  placeholder="Spletna stran" name="spletnastran" class="k-textbox" disabled />
            </label>
            <label for="spletnatrgovina" class="k-form-field">
                <span>Spletna trgovina</span>
                <input type="text" v-model="kontakt.spletnatrgovina"  placeholder="Spletna trgovina" name="spletnatrgovina" class="k-textbox" disabled />
            </label>
           
<!-- odgovorne osebe   -->


            <div style="margin-top:2rem">
             <div class="form-fieldset-header display-flex" style="align-items:center;gap:1rem;">
                <h2 >Odgovorne osebe za področje certificiranja</h2>
                <button class="ml-1 k-button k-primary" @click="dodajosebo()">Dodaj</button>
            </div>
            
            <div class="display-flex pt-1" style="flex-wrap:wrap;gap: 0.5rem;">
            <fieldset style="border:1px solid green;" v-for="(kontakt,index) in ip.osebe" :key="index">
                <div class="display-flex" style="align-items:center;justify-content:space-between">
             <div >
             </div>
                     <button class="ml-1 k-button k-error" @click="brisiosebo(index)">Briši</button>
      
    </div>
             
            <label for="ime" class="k-form-field">
                <span>Ime in priimek</span>
                <input type="text" v-model="kontakt.naziv"  placeholder="Ime in priimek" name="ime" class="k-textbox" />
            </label>
            <label for="funkcija" class="k-form-field">
                <span>Funkcija</span>
                <input type="text" v-model="kontakt.funkcija" placeholder="Funkcija"  name="funkcija" class="k-textbox" />
            </label>
           <label for="telefonnosilca" class="k-form-field">
                <span>Telefon</span>
                <input type="text" v-model="kontakt.telefon"  placeholder="Telefon" name="telefonnosilca" class="k-textbox" />
            </label>
            <label for="emailnosilca" class="k-form-field">
                <span>E-pošta</span>
                <input type="text" v-model="kontakt.email"  placeholder="Email" name="emailnosilca" class="k-textbox"  />
            </label>
            <label for="datumpooblastila" class="k-form-field">
            <span>Datum pooblastila</span>
             <kendo-datepicker id="kontakt.datumpooblastila"
                       v-model="kontakt.datumpooblastila"
                       :format="'dd.MM.yyyy'">
            </kendo-datepicker>
            </label>
            </fieldset>
           </div>

           </div>


<!-- tretje osebe   -->

<div style="margin-top:2rem">
             <div class="form-fieldset-header display-flex" style="align-items:center;gap:1rem;">
                <h2 >Izvajanje uslug za tretje osebe - podizvajalci</h2>
                <button class="ml-1 k-button k-primary" @click="dodajpodizvajalca()">Uvozi</button>
                 <input type="text" v-model="iscipodizvajalca"  placeholder="DŠ, MŠ ali KMG" name="iscipodizvajalca" class="k-textbox" />
            </div>
            <div v-if="iscipodizvajalcaerror">
                {{iscipodizvajalcaerror}}
            </div>
            
            <div class="display-flex pt-1" style="flex-wrap:wrap;gap: 0.5rem;">
            <fieldset style="border:1px solid green;" v-for="(kontakt,index) in ip.podizvajalci" :key="index">
                <div class="display-flex" style="align-items:center;justify-content:space-between">
             <div >
            </div>
                     <button class="ml-1 k-button k-error" @click="brisipodizvajalca(index)">Odstrani</button>
      
    </div>
            <label for="ime" class="k-form-field">
                <span>Naziv</span>
                <input type="text" v-model="kontakt.naziv"  placeholder="Naziv" name="ime" class="k-textbox" disabled />
            </label>
            <label for="naslovnosilca" class="k-form-field">
                <span>Naslov</span>
                <input type="text" v-model="kontakt.naslov" placeholder="Naslov"  name="naslovnosilca" class="k-textbox" disabled/>
            </label>
           <div class="k-form-field display-flex">
            <label for="postnastevilkanosilca">
                <span>Poštna številka</span>
                <input type="text" v-model="kontakt.postnastevilka"  placeholder="Poštna številka" name="postnastevilkanosilca" class="k-textbox" disabled/>
            </label>
            <label for="postanosilca" class="flex-grow-1" >
                <span>Pošta</span>
                <input type="text" v-model="kontakt.posta"  placeholder="Pošta" name="postanosilca" class="k-textbox" disabled/>
            </label>
            </div>
            <label for="telefonnosilca" class="k-form-field">
                <span>Telefon</span>
                <input type="text" v-model="kontakt.telefon"  placeholder="Telefon" name="telefonnosilca" class="k-textbox" disabled/>
            </label>
            <label for="emailnosilca" class="k-form-field">
                <span>E-pošta</span>
                <input type="text" v-model="kontakt.email"  placeholder="Email" name="emailnosilca" class="k-textbox" disabled />
            </label>
          
            <label for="odgovornaoseba" class="k-form-field">
                <span>Odgovorna oseba</span>
                <input type="text" v-model="kontakt.odgovornaoseba"  placeholder="Odgovorna oseba" name="odgovornaoseba" class="k-textbox" />
            </label>
            <label for="kmgmid" class="k-form-field">
                <span>KMG-MID</span>
                <input type="text" v-model="kontakt.kmgmid"  placeholder="KMG-MID" name="kmgmid" class="k-textbox" disabled/>
            </label>
            <label for="davcnastevilka" class="k-form-field">
                <span>Davčna številka</span>
                <input type="text" v-model="kontakt.davcnastevilka"  placeholder="Davčna številka" name="davcnastevilka" class="k-textbox" disabled/>
            </label>
            <label for="maticnastevilka" class="k-form-field">
                <span>Matična številka</span>
                <input type="text" v-model="kontakt.mso"  placeholder="Matična številka" name="maticnastevilka" class="k-textbox" disabled/>
            </label>
            </fieldset>
           </div>

           </div>








<!-- sheme   -->

<div style="margin-top:2rem">
             <div class="form-fieldset-header display-flex" style="align-items:center;gap:1rem;">
                <h2 >Aktivne sheme certificiranja pri IKC UM</h2>
            </div>
            
            <div class="display-flex pt-1" style="flex-wrap:wrap;gap: 0.5rem;flex-direction:row">
            <span class="k-button k-primary " v-for="(shema,index) in pridelovalec.sheme.filter(s=>s.jeaktivna&&s.sezona==dataSezona.sezona)" :key="index">
                {{shema.shema}}
            </span>
           </div>

</div>


<!-- zaščitni znaki   -->
<div style="margin-top:2rem">
             <div class="form-fieldset-header display-flex" style="align-items:center;gap:1rem;">
                <h2 >Uporaba zaščitnik znakov IKC UM</h2>
            </div>
 <Grid  
                       
                      
                        :data-items="ip.zascitniznaki"
                        :columns='[
                             { field: "shema", title:"Shema",editable:true,width: "150px"},
                             { field: "zacetek", title:"Začetek",editable:true,width: "150px"},
                             { field: "stproizvodov", title:"Št. proizvodov",editable:true,width: "150px"},
                             { field: "izvedel", title:"Izvedel",editable:true,width: "150px"},
                             { cell: "brisi", filterable: false, width: "220px" }
                        ]'
                        :filterable="false"
                        :sortable="false"
                        @itemchange="zascitniznakchange"
                        :edit-field="'edit'"
>
<template v-slot:brisi="{props}">
            <button class="k-button k-error " 
                    @click="removezascitniznak(props.dataItem)"
                    >
                    Briši
            </button>
        </template>
    <toolbar>
                             
                        <div class="km-widget km-buttongroup k-widget k-button-group">
                        <button title="Dodaj"
                                class="k-button k-primary"
                                @click="dodajzascitniznak"
                               >
                                Dodaj
                        </button>
                        </div>
                            
                        </toolbar>
                         <GridNoRecords >
                                        Ni podatkov!
                         </GridNoRecords>
</Grid>
</div>






            </fieldset>
             </div>
             
               
          


           
                
             </div>
        </form>
    </div>
    </div>
    </div>
    </div>

</template>

<script>
import Vue from 'vue';
import { mapState, mapActions,mapMutations } from 'vuex';
import { Grid, GridToolbar, GridNoRecords  } from '@progress/kendo-vue-grid';
import { DatePicker } from '@progress/kendo-vue-dateinputs';
import { MultiSelect, DropDownList } from '@progress/kendo-vue-dropdowns';
import { provideIntlService } from '@progress/kendo-vue-intl';
import { Checkbox } from "@progress/kendo-vue-inputs";
import PridelovalecKratko from './support/PridelovalecKratko';
import { pridelavaService } from '../services/pridelava.service';

export default {
     components: {
    'kendo-datepicker': DatePicker,
    'kendo-multiselect': MultiSelect,
    'dropdownlist': DropDownList,
    'pridelovalec':PridelovalecKratko,
    'kendo-checkbox': Checkbox,
    'Grid': Grid,
     'GridNoRecords': GridNoRecords,
      'toolbar': GridToolbar,
  },
    props:['sezona','pridelovalecid','shema'],
    data () {
        return {
                  dataSezona:this.sezona,
                   sezone:[],
            ip:{
                davcnizavezanec:false,
                eracun:false,
                eracunemail:'',
                poceniku:true,
                poponudbi:false,
                poponudbidatum:null,
                stevilkapogodobe:null,
                popust:false,
                popustznesek:'',
                individualno:true,
                skupnsko:false,
                status:{naziv:"aktiven",id:1},
                izbrandatumdolocitvestatusa:null,
                izbranosteviloclanov:0,
                izbrandatumdolocitvestevilaclanov:null,
                podrocjacertificiranja:[{naziv:"IPS",id:1},{naziv:"IPG",id:2}],
                osebe:[{}],
                podizvajalci:[{}],

            },
            statusip:[{naziv:"neaktiven",id:0},{naziv:"aktiven",id:1},{naziv:"mirovanje",id:2},{naziv:"odstop",id:3}],
            podrocjacertificiranja:[{naziv:"IPS",id:1},{naziv:"IPG",id:2},{naziv:"IPP",id:3},{naziv:"IPZ",id:4},{naziv:"IPH",id:5}],
            kmgmid:"",posta:"",postnastevilka:"",naslov:"",ime:"",priimek:"",telefon:"",email:"",opomba:"",postnastevilkakontakt:"",postakontakt:"",postnastevilkanosilec:"",postnanosilec:"",naslovkontakt:"",priimekkontakt:"",postanosilca:"",postnastevilkanosilca:"",emso:"",imekontakt:"",kntst:"",
            emailnosilca:"",telefonnosilca:"",
           
            iscipodizvajalca:'',
            iscipodizvajalcaerror:'',
            password: '',
            submitted: false,
            multiselectmessages: 
            {
            "singleTag": "izbrani elementi",
            "clear": "Počisti",
            "deleteTag": "Izbriši",
            "noData": "Ni podatkov"
            },
            vrstapridelave:["EK+K","EK-P","P"],
            
            vrsta:[],
            status:[],
            statuskategorije:[],
            kategorije:[]
        }
    },
    computed: {
        kontakt:{
            get(){
                var kontakt=this.pridelovalec?.kontakt?.find(k=>k.glavni);
                if(!kontakt)
                kontakt=this.pridelovalec?.kontakt?.find(k=>k.vloga=='nosilec kmg');
                if(!kontakt)
                kontakt=this.pridelovalec?.kontakt[0];

                return kontakt;
            }
        },
        imavezanezivali:
        {
           get() {

            return this.pridelovalec.imavezanezivali>0?true:false;
          },
          set(value) {
            this.updateprop({sezona:this.dataSezona.sezona,shema:this.shema,property:"imavezanezivali",value:value?1:0});

          }
        },
         vrstapridelovalca:
        {
           get() {

            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema==this.shema);

            if (pridelava)
                return pridelava.dejavnosti;
            else
                return [];

          }
        },
         izbranekategorije:
        {
           get() {

            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema==this.shema);

            if (pridelava)
                return pridelava.izbranekategorije;
            else
                return [];

          },
         
        },
        
        kategorijepridelovalca:
        {
           get() {

            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema==this.shema);

            if (pridelava)
                return pridelava.kategorije.map(i=>(i.id?i.id:i));
            else
                return [];

          },
          set(value){

            //let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema==this.shema);
            //pridelava.kontrolnaStevilka=value;
            console.log("UPDATE CHKBOX");
            console.log(value);
            this.updateshemaprop({sezona:this.dataSezona.sezona,shema:this.shema,property:"kategorije",value:value.map(i=>{return {id:i,status:this.statuskategorije  [i]}})});
          }
        },
        vrstapridelovalcavse:
        {
           get() {

            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema==this.shema);

            if (pridelava)
                return pridelava.vsedejavnosti;
            else
                return [];

          }
        },
        dejavnostizadruge:
        {
           get() {

            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema==this.shema);

            if (pridelava)
                return pridelava.dejavnostizadruge;
            else
                return [];

          }
        },
         kontrolnaStevilka:
        {
           get() {

            let pridelava=this.pridelovalec?.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema==this.shema);

            if (pridelava)
                return pridelava.kontrolnaStevilka;
            else
                return null;

          },
          set(value){

            //let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema==this.shema);
            //pridelava.kontrolnaStevilka=value;
            this.updateshemaprop({sezona:this.dataSezona.sezona,shema:this.shema,property:"kontrolnaStevilka",value:value});
          }

        },
         jeaktivna:
        {
           get() {
            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema==this.shema);

            if (pridelava)
                return pridelava.jeaktivna
            
            //return this.pridelovalec.sheme.find(s=>s.sezona==this.sezona&&s.shema==this.shema).jeaktivna>0?true:false;
          },
          set(value) {
            this.updateshemaprop({sezona:this.dataSezona.sezona,shema:this.shema,property:"jeaktivna",value:value?1:0});

          }
        },
        imatravojedezivali:
        {
           get() {

            return this.pridelovalec.imatravojedezivali>0?true:false;
          },
          set(value) {

           this.updateprop({property:"imatravojedezivali",value:value?1:0});

          }
        },

        izbranStatus:
        {
           get() {

             let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema==this.shema);

           if (pridelava)
                return this.status.find(s=>s.naziv==pridelava.status);
           else
                return null;
            

          },
          set(value) {
           this.updateshemaprop({sezona:this.dataSezona.sezona,shema:this.shema,property:"status",value:value.naziv});

          }
        },
         ...mapState('users', ['sezonePisanje','sheme']),
        ...mapState('pridelava', ['pridelovalec']),
        ...mapState('sifrant', ['sifrant','dataSezone'])
        
    },
    created () {
      if(!this.sezona)
        this.dataSezona={sezona:2022};
      else
      this.dataSezona={sezona:this.sezona};
    
      if(!this.shema)
        this.shema="IP";

       this.naloziPodatke(this.shema,this.sezona,this.pridelovalecid);
     
    },
    beforeRouteUpdate (to, from,next) {
    	this.naloziPodatke(to.params.shema,to.params.sezona,to.params.pridelovalecid,next);
	},
    methods: {
        
        ...mapActions({naloziSifrant: 'sifrant/load'}),
        ...mapActions('pridelava',['loadOne','save','loadIdPoSezoni']),
         ...mapMutations('pridelava',['updateprop','updateshemaprop']),

        async dodajpodizvajalca(){

        this.iscipodizvajalcaerror="";
            var podizvajalec=await pridelavaService.isciStranko(this.iscipodizvajalca?this.iscipodizvajalca:'');
        if(!podizvajalec){
            console.log("napaka")
            this.iscipodizvajalcaerror="Neuspešno iskanje";
            return;
            }

            var kontakt=podizvajalec.kontakt.find(k=>k.jeglavni);
            if(!kontakt)
                kontakt=podizvajalec.kontakt.find(k=>k.vloga=="nosilec kmg");
            if(!kontakt)
                kontakt=podizvajalec.kontakt[0];
        var k={
                
                naziv:kontakt.naziv,
                naslov:kontakt.naslov,
                postnastevilka:kontakt.postnastevilka   ,
                posta:kontakt.posta,
                telefon:kontakt.telefon,
                email:kontakt.email,
                odgovornaoseba:"",
                kmgmid:podizvajalec.kmgmid,
                davcnastevilka:podizvajalec.davcnastevilka,
                mso:podizvajalec.mso,
                
            }
            this.ip.podizvajalci.push(k);

        },
        brisipodizvajalca(index){
            this.ip.podizvajalci.splice(index,1)

        },
        dodajzascitniznak(){
            if(!this?.ip?.zascitniznaki)
                this.ip.zascitniznaki=[];

            const newRecord = { id: this.ip.zascitniznaki.length + 1,shema:'',zacetek:'',stproizvodov:'',izvedel:'',edit:true };
            this.ip.zascitniznaki.push(newRecord);
        }   ,
        removezascitniznak(e){
        
                var index=this.ip.zascitniznaki.indexOf(e);
                if(index>=0)
                        this.ip.zascitniznaki.splice(index,1)

        },
        zascitniznakchange: function (e) {
            e.dataItem[e.field]=e.value;

        console.log(this.ip.zascitniznaki);
        //this.ip.zascitniznaki.splice(index,1,e.dataItem);
  
},

          dodajosebo(){
            var k={
                glavni:false,
                naziv:"",
                naslov:"",
                postnastevilka:"",
                posta:"",
                telefon:[""],
                email:[""],
                vloga:"",
                spletnastran:"",
                drzava:"",
                kodadrzave:""
            }
            this.ip.osebe.push(k);

        },
        brisiosebo(index){
            this.ip.osebe.splice(index,1)

        },

        saveData(e){
          this.save( this.dataSezona);
        },
          handleSubmit(e){

          e.preventDefault();
        },
         cancel(e){
            this.$router.push({ name: 'sheme', params: { sezona:sezona.sezona,shema:this.shema},query:{shema:this.shema,sezona:this.sezona} })
        },
        handlestatuskategorijechange (id,event)  {
             
            //this.kategorijepridelovalca=this.kategorijepridelovalca.map(i=>{return {id:i,status:event.target.value [i]}});
            console.log("handlestatuskategorijechange");
            console.log(id);
            console.log(event.value);
            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==this.dataSezona.sezona&&s.shema==this.shema);
            var k=pridelava.kategorije.map(i=>{
                if (i.id==id)
                    return {...i,status:event.value};
                return i;   
            });
            console.log(k);
            this.updateshemaprop({sezona:this.dataSezona.sezona,shema:this.shema,property:"kategorije",value:k});


        },
        spremeniVrstoVse (event)  {
             
             this.updateshemaprop({sezona:this.dataSezona.sezona,shema:this.shema,property:"vsedejavnosti",value:[...event.target.value]});
            
        },
         spremeniVrsto (event)  {
             
             this.updateshemaprop({sezona:this.dataSezona.sezona,shema:this.shema,property:"dejavnosti",value:[...event.target.value]});
            
        },
        spremeniDejavnostiZaDruge (event)  {
             
             this.updateshemaprop({sezona:this.dataSezona.sezona,shema:this.shema,property:"dejavnostizadruge",value:[...event.target.value]});
            
        },
         spremeniStatus (event)  {
              this.izbranStatus=event.target.value;
            
        },
        zamenjajDatum(e){
            console.log(e);
            this.statusDolocen=e.value;
        },
       
        naloziPodatke (shema,sezona,pridelovalecid,next){
            //kaj če ni pridelovalca....

            // this.dataSezona={sezona:this.sezona};
       // this.dataSezone
//         this.sifrant["statuspridelovalca"]
  //       this.sifrant["vrstapridelovalca"]
         var thisComp=this;
        this.naloziSifrant({sezona:sezona,sifrant:"vrstapridelovalca"}).then(()=>{
            thisComp.vrsta=thisComp.sifrant["vrstapridelovalca"];
        });
        this.naloziSifrant({sezona:sezona,sifrant:"statuspridelovalca"}).then(()=>{
            thisComp.status=thisComp.sifrant["statuspridelovalca"];
        });

         this.naloziSifrant({sezona:sezona,sifrant:"kategorije"}).then(()=>{
            thisComp.kategorije=thisComp.sifrant["kategorije"];
        });
        this.loadOne({sezona:sezona,pridelovalecid:pridelovalecid}).then(p=>{


            let pridelava=this.pridelovalec.sheme.find(s=>s.sezona==sezona&&s.shema==shema);
            
            //provideIntlService(this).parseDate(pridelava.datumDolocitve);
          
            pridelava.ip.izbrandatumdolocitvestatusa=provideIntlService(thisComp).parseDate( pridelava.ip.izbrandatumdolocitvestatusa);
            pridelava.ip.izbrandatumdolocitvestevilaclanov=provideIntlService(thisComp).parseDate(pridelava.ip.izbrandatumdolocitvestevilaclanov)
            Vue.set(pridelava.ip,'poponudbidatum',provideIntlService(thisComp).parseDate(pridelava.ip.poponudbidatum))
            
      
            
            for (let p of this.podrocjacertificiranja)
            {
                let pp=pridelava.ip.podrocjacertificiranja.find(tmp=>tmp.naziv==p.naziv);
                
                if(!pp){
                    pridelava.ip.podrocjacertificiranja.push({
                        naziv:p.naziv,
                        id:p.id,
                        status:{naziv:"neaktiven",id:0}
                    })
                }
                else if(!pp.status)
                    pp.status={naziv:"aktiven",id:1}
                else 
                    pp.izbrandatumdolocitvestatusa=provideIntlService(this).parseDate( pp.izbrandatumdolocitvestatusa);

            }
                  console.log(pridelava)


            for (let o of pridelava.ip.osebe)
            {
                if(o.datumpooblastila)
                    o.datumpooblastila=provideIntlService(this).parseDate(o.datumpooblastila)
            }
            Vue.set(this,"ip",pridelava.ip)
            
            
            if (pridelava) {
            pridelava.kategorije.forEach(e=>{
                Vue.set(this.statuskategorije,e.id,e.status);
            });
            }
            console.log("nastavim status kategorije");
            console.log(this.statuskategorije);


            if(next)
                next();
            
        });
      
        },
         sezonaChange(event) {
         
            const sezona = event.value;
            this.dataSezona=sezona;
            this.$router.push({ name: 'ip', params: { sezona:sezona.sezona,shema:this.shema,pridelovalecid:this.pridelovalecid} })
            /*
            this.loadIdPoSezoni({sezona:sezona.sezona,pridelovalecid:this.pridelovalecid}).then(pridelovalec=>{
              this.pridelovalecid=pridelovalec.id;
             this.$router.push({ name: 'pridelovalec', params: {sezona:sezona.sezona,pridelovalecid:pridelovalec.id} });
             this.naloziPodatke();
              });

*/
          //  this.naloziPodatke();



        },
    }
};
</script>

<style scoped>

.izbranakategorija{
   background-color: var(--accent);
   
}
.k-checkbox-field {
    display: flex !important;
    align-items: center;
}
.kat_chk_list{
display:flex;
flex-direction:column;

}

form {
display:flex;
flex-direction:column;
}

.k-checkbox-field input[type="checkbox"]{
    margin-left: 0.5rem;

}
</style>